import { render, staticRenderFns } from "./ZoomablePhoto.vue?vue&type=template&id=740c8372&scoped=true"
import script from "./ZoomablePhoto.vue?vue&type=script&lang=js"
export * from "./ZoomablePhoto.vue?vue&type=script&lang=js"
import style0 from "./ZoomablePhoto.vue?vue&type=style&index=0&id=740c8372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c8372",
  null
  
)

export default component.exports